<template>
  <div class="container" id="app" :class="isLogin ? '' : 'sign-up-mode'">
    <div class="forms-container">
      <div class="signin-signup">
        <el-form
          v-show="showLoginForm"
          ref="loginRef"
          :model="loginForm"
          :rules="loginRules"
          class="sign-in-form"
        >
          <h2 class="title">用户登录</h2>
          <div class="input-field">
            <i class="icon el-icon-user-solid"></i>
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                placeholder="请输入用户名"
                @keyup.enter.native="handleLogin(loginForm)"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="input-field">
            <i class="icon el-icon-lock"></i>
            <el-form-item prop="password">
              <el-input
                v-model="loginForm.password"
                type="password"
                placeholder="请输入密码"
                show-password
                @keyup.enter.native="handleLogin(loginForm)"
              />
            </el-form-item>
          </div>
          <el-button
            class="btn form"
            type="primary"
            :loading="loginLoading"
            @click="handleLogin(loginForm)"
            round
          >
            立 即 登 录
          </el-button>
        </el-form>
        <el-form
          v-show="!showLoginForm"
          ref="signUpRef"
          :model="signUpForm"
          :rules="signUpRules"
          class="sign-up-form"
        >
          <h2 class="title">用户注册</h2>
          <div class="input-field">
            <i class="icon el-icon-user-solid"></i>
            <el-form-item prop="username">
              <el-input v-model="signUpForm.username" placeholder="请输入用户名" />
            </el-form-item>
          </div>
          <div class="input-field">
            <i class="icon el-icon-phone"></i>
            <el-form-item prop="phone">
              <el-input v-model="signUpForm.phone" type="number" placeholder="请输入手机号" />
            </el-form-item>
          </div>
          <div class="input-field">
            <i class="icon el-icon-lock"></i>
            <el-form-item prop="password">
              <el-input
                v-model="signUpForm.password"
                type="password"
                placeholder="请输入密码"
                show-password
              />
            </el-form-item>
          </div>
          <div class="input-field">
            <i class="icon el-icon-lock"></i>
            <el-form-item prop="confirmPassword">
              <el-input
                v-model="signUpForm.confirmPassword"
                type="password"
                placeholder="请再次输入密码"
                show-password
              />
            </el-form-item>
          </div>
          <el-button
            class="btn form"
            type="primary"
            :loading="signUploading"
            @click="handleSignUp(signUpForm)"
            round
          >
            立 即 注 册
          </el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/api'

export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      isLogin: true,
      showLoginForm: true,
      loginLoading: false,
      signUploading: false,
      showDlg: false,
      userRoles: [],
      rolesList: [],
      loginForm: {
        username: '',
        password: '',
      },
      signUpForm: {
        username: '',
        phone: '',
        password: '',
        confirmPassword: '',
      },
      loginRules: {
        username: [
          {
            required: true,
            message: '请输入用户名',
            type: 'string',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            type: 'string',
            trigger: 'blur',
          },
        ],
      },
      signUpRules: {
        username: [
          {
            required: true,
            message: '请输入用户名',
            type: 'string',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入11位手机号',
            type: 'string',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            type: 'string',
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.signUpForm.password) {
                callback(new Error('两次输入密码不一致!'))
              } else {
                callback()
              }
            },
            type: 'string',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {},
  watch: {
    isLogin(val) {
      setTimeout(() => {
        this.showLoginForm = val
      }, 800)
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    // 切换登录模式
    changeLogin() {
      this.isLogin = true
    },

    // 切换注册模式
    changeRegister() {
      this.isLogin = false
    },

    // 点击登录
    handleLogin() {
      this.$refs.loginRef.validate(valid => {
        if (valid) {
          this.login()
        }
      })
    },

    // 点击注册
    handleSignUp() {
      this.$refs.signUpRef.validate(valid => {
        if (valid) {
          this.signUploading = true
          setTimeout(() => {
            this.$message.success('注册成功')
            this.$refs.signUpRef.resetFields()
            this.changeLogin()
          }, 500)
        }
      })
      this.signUploading = false
    },

    // 登录
    login() {
      const { username, password } = this.loginForm

      this.loginLoading = true
      login({
        phone: username,
        password,
      })
        .then((res = {}) => {
          const JSONData = JSON.stringify(res)

          sessionStorage.setItem('userData', JSONData)

          setTimeout(() => {
            this.$router.push('/data-overview')
            this.loginLoading = false
          }, 200)
        })
        .catch((err = {}) => {
          this.$message.warning(err.message)
          this.loginLoading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  position: relative;
  width: 100%;
  background-color: #fff;
  min-height: 100vh;
  overflow: hidden;
  .forms-container {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    .signin-signup {
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      left: 75%;
      width: 50%;
      transition: 1s 0.7s ease-in-out;
      display: grid;
      grid-template-columns: 1fr;
      z-index: 5;
      form {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        transition: all 0.2s 0.7s;
        width: 800px;
        padding: 0 210px;
        .title {
          font-size: 35px;
          color: #333;
          margin-bottom: 50px;
        }
        .input-field {
          display: flex;
          align-items: center;
          width: 100%;
          padding: 0 20px;
          background-color: #f0f0f0;
          height: 55px;
          border-radius: 55px;
          margin-bottom: 20px;
          .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            margin-right: 10px;
            height: 100%;
            font-size: 20px;
            color: #acacac;
          }
          /deep/ .el-form-item {
            flex-grow: 1;
            height: 100%;
            margin: 0;
            .el-form-item__content {
              display: flex;
              align-items: center;
              height: 100%;
              .el-input {
                input {
                  background: none;
                  outline: none;
                  border: none;
                  color: #333;
                  &::placeholder {
                    color: #aaa;
                    font-weight: 500;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.btn {
  width: 150px;
  background-color: #5995fd;
  border: none;
  outline: none;
  height: 49px;
  border-radius: 49px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  margin: 10px 0;
  cursor: pointer;
  transition: 0.5s;
}

.btn:hover {
  background-color: #4d84e2;
}

.panels-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.container:before {
  content: '';
  position: absolute;
  height: 2000px;
  width: 2000px;
  top: -10%;
  right: 48%;
  transform: translateY(-50%);
  background-image: linear-gradient(-45deg, #4481eb 0%, #04befe 100%);
  transition: 1.8s ease-in-out;
  border-radius: 50%;
  z-index: 6;
}

.image {
  width: 100%;
  transition: transform 1.1s ease-in-out;
  transition-delay: 0.4s;
}

.panel {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  z-index: 6;
}

.left-panel {
  pointer-events: all;
  padding: 3rem 17% 2rem 12%;
}

.right-panel {
  pointer-events: none;
  padding: 3rem 12% 2rem 17%;
}

.panel .content {
  color: #fff;
  transition: transform 0.9s ease-in-out;
  transition-delay: 0.6s;
}

.panel h3 {
  font-weight: 600;
  line-height: 1;
  font-size: 24px;
  margin-bottom: 10px;
}

.panel p {
  font-size: 14px;
  padding: 10px 0;
}

.btn.transparent {
  margin: 0;
  background: none;
  border: 2px solid #fff;
  width: 130px;
  height: 41px;
  font-weight: 600;
  font-size: 12px;
}

.btn.transparent:hover {
  background: #fff;
  color: #5995fd;
}

.right-panel .image,
.right-panel .content {
  transform: translateX(800px);
}

/* ANIMATION */

.container.sign-up-mode:before {
  transform: translate(100%, -50%);
  right: 52%;
}

.container.sign-up-mode .left-panel .image,
.container.sign-up-mode .left-panel .content {
  transform: translateX(-800px);
}

.container.sign-up-mode .signin-signup {
  left: 25%;
}

.container.sign-up-mode form.sign-up-form {
  opacity: 1;
  z-index: 2;
}

.container.sign-up-mode form.sign-in-form {
  opacity: 0;
  z-index: 1;
}

.container.sign-up-mode .right-panel .image,
.container.sign-up-mode .right-panel .content {
  transform: translateX(0%);
}

.container.sign-up-mode .left-panel {
  pointer-events: none;
}

.container.sign-up-mode .right-panel {
  pointer-events: all;
}
</style>
